export default __webpack_public_path__ + "static/cloudator-full-2-5983e04ae3536efad94543e67e591996.png";